import { Button, CameraIcon, FolderIcon, Modal } from '@farol-ds/react'
import { useRef } from 'react'

import { ACCEPTED_FILE_INPUT } from '../../constants'
import styles from './upload-source-sheet.module.scss'

interface UploadSourceSheetProps {
  open: boolean
  onClose: () => void
  onFileSelected: (file: File) => void
  onSelectSource?: (source: 'camera' | 'gallery') => void
}

export function UploadSourceSheet(props: UploadSourceSheetProps) {
  const { open, onClose, onFileSelected, onSelectSource } = props
  const cameraInputRef = useRef<HTMLInputElement>(null)
  const galleryInputRef = useRef<HTMLInputElement>(null)

  if (!open) {
    return null
  }

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]
    if (!file) {
      return
    }

    onFileSelected(file)
    onClose()
    event.target.value = ''
  }

  return (
    <div className={styles.overlay} data-testid="upload-source-sheet">
      <div className={styles.content}>
        <Modal.Header>
          <Modal.HeaderTitle>Envio do documento de identificação</Modal.HeaderTitle>
        </Modal.Header>
        <div className={styles.actions}>
          <input
            ref={cameraInputRef}
            type="file"
            accept="image/*"
            capture="environment"
            className={styles.hiddenInput}
            onChange={handleFileChange}
          />
          <input
            ref={galleryInputRef}
            type="file"
            accept={ACCEPTED_FILE_INPUT}
            className={styles.hiddenInput}
            onChange={handleFileChange}
          />
          <Button
            kind="tertiary"
            onClick={() => {
              onSelectSource?.('camera')
              cameraInputRef.current?.click()
            }}
          >
            <CameraIcon />
            Tirar foto agora
          </Button>
          <Button
            kind="tertiary"
            onClick={() => {
              onSelectSource?.('gallery')
              galleryInputRef.current?.click()
            }}
          >
            <FolderIcon />
            Escolher da galeria
          </Button>
        </div>
      </div>
    </div>
  )
}
